import { render, staticRenderFns } from "./traning-recorde.vue?vue&type=template&id=3f4342c5&scoped=true&lang=pug"
import script from "./traning-recorde.vue?vue&type=script&lang=js"
export * from "./traning-recorde.vue?vue&type=script&lang=js"
import style0 from "./traning-recorde.vue?vue&type=style&index=0&id=3f4342c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4342c5",
  null
  
)

export default component.exports